import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, CoreModule],
  providers: [providePrimeNG({ theme: { preset: Lara, options: { darkModeSelector: '[data-theme="dark"]', cssLayer: true } } })],
  bootstrap: [AppComponent],
})
export class AppModule {}
